const codes = [
    900005,
    40308, // 直播未发布
    40309, // 无权限参加直播
    40305, // 直播参与人数超过计划人数
    100005 // 直播隐藏
];

// 资源不存在
const resourcesEmptyCodes = [900005, 30117, 30126, 40206, 40308, 30520, 60104, 100005];

// 没有权限
const resourcesAuthCodes = [30120, 40205, 40901, 40309, 30521, 39040];

//  人数超出
const memberCountLimitCodes = [40305];

export const hasCode = (code) => {
    const mergeArr = codes.concat(resourcesEmptyCodes, resourcesAuthCodes, memberCountLimitCodes);
    const codeStr = mergeArr.join(',');
    return codeStr.indexOf(code) > -1;
};

export const isEmptyCode = (code) => {
    const result = resourcesEmptyCodes.join(',').indexOf(code) > -1;
    return result;
};

export const isAuthCode = (code) => {
    const result = resourcesAuthCodes.join(',').indexOf(code) > -1;
    return result;
};

export const isMemberLimitCode = (code) => {
    const result = memberCountLimitCodes.join(',').indexOf(code) > -1;
    return result;
};
